module.exports = ".page-size-selector {\n  float: left; }\n  .page-size-selector label {\n    float: left; }\n  .page-size-selector select {\n    float: left; }\n  .pagination a.disabled {\n  color: gray;\n  cursor: not-allowed;\n  text-decoration: none; }\n  #norecords {\n  background-color: #f7f7f7;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/controls/spk-pager/spk-pager.component.scss
// module id = ./src/app/components/framework/spk/controls/spk-pager/spk-pager.component.scss
// module chunks = main